import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  VideoURLDescription: {
    id: 'Select an internal Video item or type an external URL',
    defaultMessage: 'Select an internal Video item or type an external URL',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Preview Image URL',
  },
  Alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
});

export const VideoBlockSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.Video),
    block: 'Video',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['url', 'preview_image', 'align'],
      },
    ],

    properties: {
      url: {
        title: props.intl.formatMessage(messages.VideoURL),
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
        selectedItemAttrs: ['Title', 'Description', '@type'],
        selectableTypes: ['Video'],
        description: props.intl.formatMessage(messages.VideoURLDescription),
      },
      preview_image: {
        title: props.intl.formatMessage(messages.Preview_image),
        widget: 'url',
      },
      align: {
        title: props.intl.formatMessage(messages.Alignment),
        widget: 'align',
      },
    },
    required: [],
  };
};

export default VideoBlockSchema;
